"use client";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import SingleSelectPill from "./SingleSelectPill";

const SingleSelectInput = ({
  setFormState,
  formState,
  questionKey,
  options,
  theme,
}: TInputProps) => {
  const selectedValue = formState?.[questionKey];

  const handleSelectChange = (val: string) => {
    setFormState((p) => {
      localStorage.setItem(
        "bioFormData",
        JSON.stringify({ ...p, [questionKey]: val })
      );
      return { ...p, [questionKey]: val };
    });
  };

  return (
    <div>
      <div className="grid grid-cols-2 gap-4 ">
        {options?.map((option) => {
          const isSelected = option.option === selectedValue;
          return (
            <button
              key={option.option}
              className="w-full flex  items-start"
              onClick={() => handleSelectChange(option.option)}
            >
              <SingleSelectPill isSelected={isSelected} theme={theme}>
                {option.option}
              </SingleSelectPill>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SingleSelectInput;

export type TInput = "text" | "single_select" | "multi_select";

export type TInputProps = {
  setFormState: Dispatch<SetStateAction<Record<questionKey, string | number>>>;
  questionKey: questionKey;
  options?: { option: string; mark: number | string }[];
  formState: Record<questionKey, string | number>;
  theme: string[];
};
type questionKey = "" | any;
